import {ListConfigs} from '../../../sharedComponent/SearchList/SearchList.types'

export const AGENTLEADERLISTCONFIGS: ListConfigs[] = [
  {
    headerName: 'Agent Leader Name',
    apiFieldName: 'leaderName',
    type: 'TEXT',
    columnWidth: '180',
  },
  {
    headerName: 'Agent Leader Code',
    apiFieldName: 'leaderCode',
    type: 'TEXT',
    columnWidth: '149',
  },
  {
    headerName: 'Status',
    apiFieldName: 'leaderStatus',
    type: 'ACTIVE_BADGE',
    columnWidth: '149',
  },
]

export const AGENTLEADERMOCKAPITDATA = [
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
  {
    leaderName: 'Hello ',
    leaderCode: 'JEK',
    isActive: false,
  },
]
